import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTransferIconSecondary from './svgs/TransferIconSecondary.js';
import SvgTransferIcon from './svgs/TransferIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var transferIcon = (props => useIcon(SvgTransferIcon, SvgTransferIconSecondary, props));

export { transferIcon as default };
